import React, {useState} from "react";

import {View, Text, ScrollView, StyleSheet, TouchableOpacity, Image, FlatList, Dimensions} from "react-native";
import AntDesign from "@expo/vector-icons/AntDesign";
import Config from "../../../Config";
import {RFValue} from "react-native-responsive-fontsize";
import {Entypo, EvilIcons, FontAwesome, FontAwesome6, MaterialIcons} from "@expo/vector-icons";
import Feather from "@expo/vector-icons/Feather";
import AsyncStorage from "@react-native-async-storage/async-storage";
import axios from "axios";
import Toast from "../../Components/Toast";
import Loading from "../../Components/Loading";
import NumberFormat from "../../Components/NumberFormat";


const Newcourses =({navigation})=>{

    let [data, setData] = useState(false);
    React.useEffect(() => {
        getData();
    },[]);


    let getData = async ()=>{
        try {
            let token = await AsyncStorage.getItem('token');
            let res = await axios.get(`${Config.api}/user/lastcourses`,{ 'headers': {  Authorization: 'Bearer '+token} });
            if(res.data.code != 1){
                // alert(JSON.stringify(res.data));
                // console.log(res.data.data);
                Toast(res.data.error);
            }
            setData( res.data);

        } catch (err) {
            console.log(err);
            alert('خطا')
        }
    }


    const renderItem = ({item}) => {


        return (
            <TouchableOpacity onPress={()=>{navigation.navigate('InfoCourse',{course_id : item.id ,back : 1})}} style={styles.item}>
                <Image resizeMode={'stretch'} style={styles.image} source={{uri : `${Config.base}/${item.image}`}} />
                <Text style={styles.namecourse}>
                    {item.name}
                </Text>
                <View style={styles.rowitem}>
                    <Text style={styles.label}>
                        تعداد قسمت ها:
                    </Text>
                    <Text style={styles.val}>
                        {item.lessons_count}
                        {/*درس*/}
                    </Text>
                </View>
                {/*<View style={styles.rowitem}>*/}
                {/*    <Text style={styles.label}>*/}
                {/*        مدت زمان:*/}
                {/*    </Text>*/}
                {/*    <Text style={styles.val}>*/}
                {/*        {item.time}*/}
                {/*    </Text>*/}
                {/*</View>*/}
                <View style={styles.rowitem2}>
                    <Text style={styles.label}>
                        سطح دوره:
                    </Text>
                    <Text style={styles.val}>
                        {item.level}
                    </Text>
                </View>
                <View style={styles.cart}>
                    <EvilIcons name="cart" size={RFValue(20)} color={Config.maincolor} />

                        {item.price == 0 ?
                            <Text style={styles.number}>
                                رایگان
                            </Text>
                            :
                            <Text style={styles.number}>
                                <NumberFormat number={item.price} />
                                {` `}
                                تومان
                            </Text>
                        }


                </View>
            </TouchableOpacity>
        );
    };


    return (
        <View style={styles.container}>
            <View style={styles.header}>
                <Text style={styles.title}>
                    دوره های جدید
                </Text>
            </View>

            {data ?

                <FlatList  contentContainerStyle={styles.content}   keyExtractor={item => item.id}  data={data.courses} renderItem={renderItem} />

                // <ScrollView style={{flex : 1 , backgroundColor:'white' }}>
                //
                //
                //
                //
                //
                //     <View style={styles.content}>
                //
                //
                //
                //         <TouchableOpacity style={styles.item}>
                //             <Image style={styles.image} source={require('../../../assets/images/course.png')} />
                //             <View style={styles.rowitem}>
                //                 <Text style={styles.label}>
                //                     تعداد جلسات:
                //                 </Text>
                //                 <Text style={styles.val}>
                //                     10 درس
                //                 </Text>
                //             </View>
                //             <View style={styles.rowitem}>
                //                 <Text style={styles.label}>
                //                     مدت زمان:
                //                 </Text>
                //                 <Text style={styles.val}>
                //                     8 ساعت
                //                 </Text>
                //             </View>
                //             <View style={styles.rowitem}>
                //                 <Text style={styles.label}>
                //                     سطح دوره:
                //                 </Text>
                //                 <Text style={styles.val}>
                //                     B1
                //                 </Text>
                //             </View>
                //             <View style={styles.cart}>
                //                 <EvilIcons name="cart" size={RFValue(20)} color={Config.maincolor} />
                //                 <Text style={styles.number}>
                //                     1,000,000 تومان
                //                 </Text>
                //
                //             </View>
                //         </TouchableOpacity>
                //         <TouchableOpacity style={styles.item}>
                //             <Image style={styles.image} source={require('../../../assets/images/course.png')} />
                //             <View style={styles.rowitem}>
                //                 <Text style={styles.label}>
                //                     تعداد جلسات:
                //                 </Text>
                //                 <Text style={styles.val}>
                //                     10 درس
                //                 </Text>
                //             </View>
                //             <View style={styles.rowitem}>
                //                 <Text style={styles.label}>
                //                     مدت زمان:
                //                 </Text>
                //                 <Text style={styles.val}>
                //                     8 ساعت
                //                 </Text>
                //             </View>
                //             <View style={styles.rowitem}>
                //                 <Text style={styles.label}>
                //                     سطح دوره:
                //                 </Text>
                //                 <Text style={styles.val}>
                //                     B1
                //                 </Text>
                //             </View>
                //             <View style={styles.cart}>
                //                 <EvilIcons name="cart" size={RFValue(20)} color={Config.maincolor} />
                //                 <Text style={styles.number}>
                //                     1,000,000 تومان
                //                 </Text>
                //
                //             </View>
                //         </TouchableOpacity>
                //         <TouchableOpacity style={styles.item}>
                //             <Image style={styles.image} source={require('../../../assets/images/course.png')} />
                //             <View style={styles.rowitem}>
                //                 <Text style={styles.label}>
                //                     تعداد جلسات:
                //                 </Text>
                //                 <Text style={styles.val}>
                //                     10 درس
                //                 </Text>
                //             </View>
                //             <View style={styles.rowitem}>
                //                 <Text style={styles.label}>
                //                     مدت زمان:
                //                 </Text>
                //                 <Text style={styles.val}>
                //                     8 ساعت
                //                 </Text>
                //             </View>
                //             <View style={styles.rowitem}>
                //                 <Text style={styles.label}>
                //                     سطح دوره:
                //                 </Text>
                //                 <Text style={styles.val}>
                //                     B1
                //                 </Text>
                //             </View>
                //             <View style={styles.cart}>
                //                 <EvilIcons name="cart" size={RFValue(20)} color={Config.maincolor} />
                //                 <Text style={styles.number}>
                //                     1,000,000 تومان
                //                 </Text>
                //
                //             </View>
                //         </TouchableOpacity>
                //         <TouchableOpacity style={styles.item}>
                //             <Image style={styles.image} source={require('../../../assets/images/course.png')} />
                //             <View style={styles.rowitem}>
                //                 <Text style={styles.label}>
                //                     تعداد جلسات:
                //                 </Text>
                //                 <Text style={styles.val}>
                //                     10 درس
                //                 </Text>
                //             </View>
                //             <View style={styles.rowitem}>
                //                 <Text style={styles.label}>
                //                     مدت زمان:
                //                 </Text>
                //                 <Text style={styles.val}>
                //                     8 ساعت
                //                 </Text>
                //             </View>
                //             <View style={styles.rowitem}>
                //                 <Text style={styles.label}>
                //                     سطح دوره:
                //                 </Text>
                //                 <Text style={styles.val}>
                //                     B1
                //                 </Text>
                //             </View>
                //             <View style={styles.cart}>
                //                 <EvilIcons name="cart" size={RFValue(20)} color={Config.maincolor} />
                //                 <Text style={styles.number}>
                //                     1,000,000 تومان
                //                 </Text>
                //
                //             </View>
                //         </TouchableOpacity>
                //         <TouchableOpacity style={styles.item}>
                //             <Image style={styles.image} source={require('../../../assets/images/course.png')} />
                //             <View style={styles.rowitem}>
                //                 <Text style={styles.label}>
                //                     تعداد جلسات:
                //                 </Text>
                //                 <Text style={styles.val}>
                //                     10 درس
                //                 </Text>
                //             </View>
                //             <View style={styles.rowitem}>
                //                 <Text style={styles.label}>
                //                     مدت زمان:
                //                 </Text>
                //                 <Text style={styles.val}>
                //                     8 ساعت
                //                 </Text>
                //             </View>
                //             <View style={styles.rowitem}>
                //                 <Text style={styles.label}>
                //                     سطح دوره:
                //                 </Text>
                //                 <Text style={styles.val}>
                //                     B1
                //                 </Text>
                //             </View>
                //             <View style={styles.cart}>
                //                 <EvilIcons name="cart" size={RFValue(20)} color={Config.maincolor} />
                //                 <Text style={styles.number}>
                //                     1,000,000 تومان
                //                 </Text>
                //
                //             </View>
                //         </TouchableOpacity>
                //         <TouchableOpacity style={styles.item}>
                //             <Image style={styles.image} source={require('../../../assets/images/course.png')} />
                //             <View style={styles.rowitem}>
                //                 <Text style={styles.label}>
                //                     تعداد جلسات:
                //                 </Text>
                //                 <Text style={styles.val}>
                //                     10 درس
                //                 </Text>
                //             </View>
                //             <View style={styles.rowitem}>
                //                 <Text style={styles.label}>
                //                     مدت زمان:
                //                 </Text>
                //                 <Text style={styles.val}>
                //                     8 ساعت
                //                 </Text>
                //             </View>
                //             <View style={styles.rowitem}>
                //                 <Text style={styles.label}>
                //                     سطح دوره:
                //                 </Text>
                //                 <Text style={styles.val}>
                //                     B1
                //                 </Text>
                //             </View>
                //             <View style={styles.cart}>
                //                 <EvilIcons name="cart" size={RFValue(20)} color={Config.maincolor} />
                //                 <Text style={styles.number}>
                //                     1,000,000 تومان
                //                 </Text>
                //
                //             </View>
                //         </TouchableOpacity>
                //         <TouchableOpacity style={styles.item}>
                //             <Image style={styles.image} source={require('../../../assets/images/course.png')} />
                //             <View style={styles.rowitem}>
                //                 <Text style={styles.label}>
                //                     تعداد جلسات:
                //                 </Text>
                //                 <Text style={styles.val}>
                //                     10 درس
                //                 </Text>
                //             </View>
                //             <View style={styles.rowitem}>
                //                 <Text style={styles.label}>
                //                     مدت زمان:
                //                 </Text>
                //                 <Text style={styles.val}>
                //                     8 ساعت
                //                 </Text>
                //             </View>
                //             <View style={styles.rowitem}>
                //                 <Text style={styles.label}>
                //                     سطح دوره:
                //                 </Text>
                //                 <Text style={styles.val}>
                //                     B1
                //                 </Text>
                //             </View>
                //             <View style={styles.cart}>
                //                 <EvilIcons name="cart" size={RFValue(20)} color={Config.maincolor} />
                //                 <Text style={styles.number}>
                //                     1,000,000 تومان
                //                 </Text>
                //
                //             </View>
                //         </TouchableOpacity>
                //
                //
                //
                //
                //     </View>
                // </ScrollView>
                :
                <Loading/>

            }



        </View>
    );
}

const styles = StyleSheet.create({
    number : {
        fontSize: RFValue(10),
        fontFamily : 'ykb',
        color: Config.maincolor,

    },

    cart : {
      backgroundColor: Config.secondcolor,
        // width: '100%',
        width: RFValue(135),
        flexBasis: 'auto',
        flexShrink : 'auto',
        padding : RFValue(3),
        height : RFValue(22),
        borderRadius: 20,
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: RFValue(5),
    },

    label : {
      fontFamily : 'ykb',
        color : '#0D1134',
        fontSize : RFValue(12),
        // backgroundColor  : 'red'
    },
    val : {
        fontFamily : 'yk',
        color : '#0D1134',
        marginRight : RFValue(4),
        fontSize : RFValue(12),

    },

    rowitem : {
      flexDirection : 'row',
        justifyContent : 'flex-start',
        alignItems: 'flex-start',
        // backgroundColor:'red',
        width: Dimensions.get("window").width / 2 - 45,
        paddingTop: RFValue(0),
    },
    rowitem2 : {
        flexDirection : 'column',
        alignItems: 'flex-start',
        width: Dimensions.get("window").width / 2 - 45,
        paddingTop: RFValue(4),
    },
    namecourse : {
        marginTop: RFValue(8),
        fontFamily : 'ykb',
        // color : Config.secondcolor,
        // color : Config.maincolor,
        color : 'black',
        fontSize : RFValue(14),
        // textAlign: 'center',
        // backgroundColor : 'red',
    },

    image: {
        width: RFValue(135),
        height: RFValue(92),
        borderRadius: RFValue(15),
    },

    itmtxt : {
        fontSize: RFValue(14),
        fontFamily : 'yk',
        color: 'white',
        marginRight : RFValue(20),

    },


    item : {
        // width: '40%',
        justifyContent : 'flex-start',
        alignItems : 'center',
        marginBottom: RFValue(20),
    },

    content : {
        flexGrow: 1,

        paddingHorizontal: RFValue(20),
        backgroundColor : 'white',
        flexDirection : 'row',
        justifyContent : 'space-between',
        flexWrap : 'wrap',
        alignItems: 'center',

        paddingTop: RFValue(10),



    },

    container : {
        flex: 1,
        backgroundColor: Config.maincolor,
    },
    header: {
        backgroundColor: '#000422',
        paddingHorizontal: RFValue(20),
        paddingVertical: RFValue(14),

        shadowColor:"#000000",
        shadowOffset: {
            width: 0,
            height: 50,
        },
        shadowOpacity: 1,
        shadowRadius: 0,
        elevation: 1
    },


    title : {
        fontSize: RFValue(18),
        fontFamily : 'ykb',
        color: 'white',
    }
})


export default Newcourses